export default "__VITE_ASSET__BIOd3ZnQ__"